import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { TransportInterventionsMapPoiReportPopupComponent } from './transport-interventions-map-poi-report-popup.component';
import {DxDataGridModule, DxTabsModule} from 'devextreme-angular';

@NgModule({
  declarations: [TransportInterventionsMapPoiReportPopupComponent],
  imports: [
    CommonModule,
    DxTabsModule,
    DxDataGridModule,
  ],
  exports: [TransportInterventionsMapPoiReportPopupComponent]
})
export class TransportInterventionsMapPoiReportPopupModule { }
